/**
 * Maps human-readable keys to translation IDs for the `/tools` index page.
 *
 * The tool cards themselves are NOT here: their titles and descriptions live
 * in the shared `healthTools` namespace (i18n/health-tools-keys.ts), because
 * the cross-link section on each tool page renders the same copy. This
 * namespace owns only what belongs to the index page itself.
 *
 * Gated to CH + DE, so `de-DE` is held to full parity on this namespace;
 * `de-AT`, `en-NL` and `nl` still exempt it in `SKIP_NAMESPACES_PER_LOCALE`
 * (scripts/lint-mirror-locales.ts). It ships in every locale its markets
 * offer: all three in CH, German in DE.
 */
export const toolsKeys = {
  metaTitle: "tools_metaTitle",
  metaDescription: "tools_metaDescription",

  heading: "tools_heading",
  subheading: "tools_subheading",

  ctaHeading: "tools_ctaHeading",
  ctaBody: "tools_ctaBody",
  ctaPrimary: "tools_ctaPrimary",
  ctaSecondary: "tools_ctaSecondary",

  disclaimer: "tools_disclaimer",
} as const
